module.exports = new __parcel__URL__("error-subtle.580d9941.svg").toString();